/** Premium cuts — GLBs in /public (Vite serves at root). */
export const PRIME_CUTS = [
  {
    path: '/Meshy_AI_raw_ribeye_steak_hig_0424004650_texture.glb',
    slug: 'ribeye',
    name: 'Raw ribeye',
    headline: 'Center-cut beef, retail-ready',
    tagline:
      'Rich marbling and clean trim — the cut customers photograph and remember. Your catalog and storefront deserve this level of detail.'
  },
  {
    path: '/Meshy_AI_Bone_In_Ribeye_on_a_W_0424010423_texture.glb',
    slug: 'bone-in-ribeye',
    name: 'Bone-in ribeye',
    headline: 'Butcher-block presence',
    tagline:
      'Bone-in drama for premium positioning: perfect for hero imagery, specials boards, and high-ticket baskets in your tenant stores.'
  },
  {
    path: '/Meshy_AI_Raw_Chicken_and_Pork__0424011945_texture.glb',
    slug: 'chicken-pork-selection',
    name: 'Chicken & pork selection',
    headline: 'Everyday favorites, premium presentation',
    tagline:
      'A polished hero cut for high-volume staples. Showcase freshness, consistency, and quality across your storefront and promotions.'
  }
];

/** Total scroll “pages” (each ≈ 100vh) in ScrollControls. */
export const SCROLL_PAGES = 10;

/**
 * Which cut (0..cutCount-1) to show for the current scroll page.
 * First `min(3, cutCount)` pages: spotlight each available cut; then cycle during features.
 */
export function cutIndexForPage(pageIndex, cutCount) {
  const n = Math.max(1, cutCount);
  const p = Math.max(0, Math.min(SCROLL_PAGES - 1, pageIndex));
  const spotlightPages = Math.min(3, n);
  if (p < spotlightPages) return p % n;
  if (p < 9) return ((p - spotlightPages) % n + n) % n;
  return 0;
}
